let scrollingHideCount = 0;

export function DateValid(date) {
  if (!date) return false;
  let dateFields = date.split("/");
  let year = parseInt(dateFields[2]);
  let month = parseInt(dateFields[0]);
  let day = parseInt(dateFields[1]);

  if (isNaN(year) || isNaN(month) || isNaN(day)) return false;

  const monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // adjust monthDays for leap year
  let leap = false;
  if (year % 4 == 0) {
    if (year % 100 == 0) {
      if (year % 400 == 0) leap = true;
    } else leap = true;
  }
  if (leap) monthDays[1] = 29;

  if (year <= 0) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > monthDays[month - 1]) return false;

  return true;
}

export function TimeValid(time) {
  let timeFields = time.split(":");
  let hour = timeFields[0];
  let minute = timeFields[1];

  if (isNaN(hour) || isNaN(minute)) return false;

  if (hour < 0 || hour > 23) return false;
  if (minute < 0 || minute > 59) return false;

  return true;
}

export function ParseNumber(value, defaultValue = 0) {
  if (isNaN(value) || value == null || typeof value == "undefined" || isNaN(Number(value))) return defaultValue;
  else return Number(value);
}

export function ScrollingDisable() {
  scrollingHideCount--;
  if (scrollingHideCount < 0 && !document.body.classList.contains("body-overflow-hidden"))
    document.body.classList.add("body-overflow-hidden");
}

export function ScrollingEnable() {
  scrollingHideCount++;
  if (scrollingHideCount == 0 && document.body.classList.contains("body-overflow-hidden")) {
    document.body.classList.remove("body-overflow-hidden");
  }
}

export function FormatPilotName(firstname, middlenames, lastname) {
  let pilotName = lastname.toUpperCase() + ", " + firstname;
  if (middlenames) pilotName += " " + middlenames;
  return pilotName;
}


export function GetStateList() {
  return {
    AL: "Alabama",
    AK: "Alaska",
    AS: "American Samoa",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    MP: "Northern Mariana Islands",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    VI: "U.S. Virgin Islands",
    UM: "United States Minor Outlying Islands",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  };
}

export function getStateFromZip(zipString) {
  let zipcodeRegExpn = /^\d{5}$/;
  if(!zipcodeRegExpn.test(zipString))
    return false;

  /* Ensure we don't parse strings starting with 0 as octal values */
  const zipcode = parseInt(zipString, 10);

  let stateCode;
  let state;

  /* Code cases alphabetized by state */
  if (zipcode >= 35000 && zipcode <= 36999) {
    stateCode = "AL";
    state = "Alabama";
  } else if (zipcode >= 99500 && zipcode <= 99999) {
    stateCode = "AK";
    state = "Alaska";
  } else if (zipcode >= 85000 && zipcode <= 86999) {
    stateCode = "AZ";
    state = "Arizona";
  } else if (zipcode >= 71600 && zipcode <= 72999) {
    stateCode = "AR";
    state = "Arkansas";
  } else if (zipcode >= 90000 && zipcode <= 96699) {
    stateCode = "CA";
    state = "California";
  } else if (zipcode >= 80000 && zipcode <= 81999) {
    stateCode = "CO";
    state = "Colorado";
  } else if (zipcode >= 6000 && zipcode <= 6999) {
    stateCode = "CT";
    state = "Connecticut";
  } else if (zipcode >= 19700 && zipcode <= 19999) {
    stateCode = "DE";
    state = "Delaware";
  } else if (zipcode >= 32000 && zipcode <= 34999) {
    stateCode = "FL";
    state = "Florida";
  } else if (zipcode >= 30000 && zipcode <= 31999) {
    stateCode = "GA";
    state = "Georgia";
  } else if (zipcode >= 96700 && zipcode <= 96999) {
    stateCode = "HI";
    state = "Hawaii";
  } else if (zipcode >= 83200 && zipcode <= 83999) {
    stateCode = "ID";
    state = "Idaho";
  } else if (zipcode >= 60000 && zipcode <= 62999) {
    stateCode = "IL";
    state = "Illinois";
  } else if (zipcode >= 46000 && zipcode <= 47999) {
    stateCode = "IN";
    state = "Indiana";
  } else if (zipcode >= 50000 && zipcode <= 52999) {
    stateCode = "IA";
    state = "Iowa";
  } else if (zipcode >= 66000 && zipcode <= 67999) {
    stateCode = "KS";
    state = "Kansas";
  } else if (zipcode >= 40000 && zipcode <= 42999) {
    stateCode = "KY";
    state = "Kentucky";
  } else if (zipcode >= 70000 && zipcode <= 71599) {
    stateCode = "LA";
    state = "Louisiana";
  } else if (zipcode >= 3900 && zipcode <= 4999) {
    stateCode = "ME";
    state = "Maine";
  } else if (zipcode >= 20600 && zipcode <= 21999) {
    stateCode = "MD";
    state = "Maryland";
  } else if (zipcode >= 1000 && zipcode <= 2799) {
    stateCode = "MA";
    state = "Massachusetts";
  } else if (zipcode >= 48000 && zipcode <= 49999) {
    stateCode = "MI";
    state = "Michigan";
  } else if (zipcode >= 55000 && zipcode <= 56999) {
    stateCode = "MN";
    state = "Minnesota";
  } else if (zipcode >= 38600 && zipcode <= 39999) {
    stateCode = "MS";
    state = "Mississippi";
  } else if (zipcode >= 63000 && zipcode <= 65999) {
    stateCode = "MO";
    state = "Missouri";
  } else if (zipcode >= 59000 && zipcode <= 59999) {
    stateCode = "MT";
    state = "Montana";
  } else if (zipcode >= 27000 && zipcode <= 28999) {
    stateCode = "NC";
    state = "North Carolina";
  } else if (zipcode >= 58000 && zipcode <= 58999) {
    stateCode = "ND";
    state = "North Dakota";
  } else if (zipcode >= 68000 && zipcode <= 69999) {
    stateCode = "NE";
    state = "Nebraska";
  } else if (zipcode >= 88900 && zipcode <= 89999) {
    stateCode = "NV";
    state = "Nevada";
  } else if (zipcode >= 3000 && zipcode <= 3899) {
    stateCode = "NH";
    state = "New Hampshire";
  } else if (zipcode >= 7000 && zipcode <= 8999) {
    stateCode = "NJ";
    state = "New Jersey";
  } else if (zipcode >= 87000 && zipcode <= 88499) {
    stateCode = "NM";
    state = "New Mexico";
  } else if (zipcode >= 10000 && zipcode <= 14999) {
    stateCode = "NY";
    state = "New York";
  } else if (zipcode >= 43000 && zipcode <= 45999) {
    stateCode = "OH";
    state = "Ohio";
  } else if (zipcode >= 73000 && zipcode <= 74999) {
    stateCode = "OK";
    state = "Oklahoma";
  } else if (zipcode >= 97000 && zipcode <= 97999) {
    stateCode = "OR";
    state = "Oregon";
  } else if (zipcode >= 15000 && zipcode <= 19699) {
    stateCode = "PA";
    state = "Pennsylvania";
  } else if (zipcode >= 300 && zipcode <= 999) {
    stateCode = "PR";
    state = "Puerto Rico";
  } else if (zipcode >= 2800 && zipcode <= 2999) {
    stateCode = "RI";
    state = "Rhode Island";
  } else if (zipcode >= 29000 && zipcode <= 29999) {
    stateCode = "SC";
    state = "South Carolina";
  } else if (zipcode >= 57000 && zipcode <= 57999) {
    stateCode = "SD";
    state = "South Dakota";
  } else if (zipcode >= 37000 && zipcode <= 38599) {
    stateCode = "TN";
    state = "Tennessee";
  } else if ((zipcode >= 75000 && zipcode <= 79999) || (zipcode >= 88500 && zipcode <= 88599)) {
    stateCode = "TX";
    state = "Texas";
  } else if (zipcode >= 84000 && zipcode <= 84999) {
    stateCode = "UT";
    state = "Utah";
  } else if (zipcode >= 5000 && zipcode <= 5999) {
    stateCode = "VT";
    state = "Vermont";
  } else if (zipcode >= 22000 && zipcode <= 24699) {
    stateCode = "VA";
    state = "Virgina";
  } else if (zipcode >= 20000 && zipcode <= 20599) {
    stateCode = "DC";
    state = "Washington DC";
  } else if (zipcode >= 98000 && zipcode <= 99499) {
    stateCode = "WA";
    state = "Washington";
  } else if (zipcode >= 24700 && zipcode <= 26999) {
    stateCode = "WV";
    state = "West Virginia";
  } else if (zipcode >= 53000 && zipcode <= 54999) {
    stateCode = "WI";
    state = "Wisconsin";
  } else if (zipcode >= 82000 && zipcode <= 83199) {
    stateCode = "WY";
    state = "Wyoming";
  }

  if (!stateCode || !state) return false;
  else return { code: stateCode, name: state };
}
